// import CryptoJS from "crypto-js";

// // คีย์และ IV ต้องยาว 16 byte
// const SECRET_KEY = CryptoJS.enc.Utf8.parse("1234567890123456");
// const FIXED_IV = CryptoJS.enc.Utf8.parse("abcdefg123456789");
// test
const PREFIX = process.env.REACT_APP_DEFAULT_AGENT_CODE;

export function encryptWithPrefix(value) {
  // const encrypted = CryptoJS.AES.encrypt(value.toString(), SECRET_KEY, {
  //   iv: FIXED_IV,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7,
  // }).toString();

  // return PREFIX + encrypted; // ✅ ต่อชื่อเว็บด้านหน้า
  return PREFIX + "" + value;
}

export function decryptWithPrefix(prefixedValue) {
  // if (!prefixedValue.startsWith(PREFIX)) {
  //   console.error("ไม่ใช่ข้อมูลที่เข้ารหัสโดยระบบนี้");
  //   return null;
  // }

  const encryptedOnly = prefixedValue.slice(PREFIX.length); // 🔄 ตัด prefix ออก
  // const decrypted = CryptoJS.AES.decrypt(encryptedOnly, SECRET_KEY, {
  //   iv: FIXED_IV,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7,
  // });

  // return decrypted.toString(CryptoJS.enc.Utf8);
  return encryptedOnly;
}
